import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import {Typeahead} from 'react-bootstrap-typeahead';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import {lock} from 'react-icons-kit/icomoon/lock';
import {unlocked} from 'react-icons-kit/icomoon/unlocked';
import {search} from 'react-icons-kit/icomoon/search';
import SvgIcon from 'react-icons-kit';
import ModalPhenotype from '../petition_register/modalPhenotype';
import ModalAuth from './modalAuth';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import Inputmask from 'inputmask';
import WaitingModal from '../../generics/WaitingModal';
import {pencil} from 'react-icons-kit/icomoon/pencil';
import {bin} from 'react-icons-kit/icomoon/bin';
import {floppyDisk} from 'react-icons-kit/icomoon/floppyDisk';
import {cross} from 'react-icons-kit/icomoon/cross';
import {print} from 'react-icons-kit/fa/print';
import {history} from 'react-icons-kit/icomoon/history';
import {upload2} from 'react-icons-kit/icomoon/upload2';
import ModalData from './modalData';
import ModalReport from '../petition_register/modalReport';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ModalHistory from './modalHistory';
import $ from 'jquery';

var Config = require('../../../config');

class UnitReserve extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.loadComponent = this.loadComponent.bind(this);
		this.viewPhenotypes = this.viewPhenotypes.bind(this);
		this.getcross_test_results = this.getcross_test_results.bind(this);
		this.getSamples = this.getSamples.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.printLabel = this.printLabel.bind(this);
		this.verifyCompatibility = this.verifyCompatibility.bind(this);
		this.viewAuth = this.viewAuth.bind(this);
		this.updateTables = this.updateTables.bind(this);
		this.deleteUnitReserved = this.deleteUnitReserved.bind(this);
		this.printReport = this.printReport.bind(this);
		this.verifyCaducidad = this.verifyCaducidad.bind(this);
		this.saving = this.saving.bind(this);
		this.getPetitions = this.getPetitions.bind(this);

		this.updateTableAfterAuth = this.updateTableAfterAuth.bind(this);

		this.onSaveAnalize = this.onSaveAnalize.bind(this);
		this.changeReason = this.changeReason.bind(this);
		this.getDeletedUnits = this.getDeletedUnits.bind(this);
		this.saveManual = this.saveManual.bind(this);
		this.openHistory = this.openHistory.bind(this);
		this.getCriteriaAutoComp = this.getCriteriaAutoComp.bind(this);

		this.state = {
			isLoading: false,
			isLoading_1: false,
			no_file: "",
			patient:"",
			table_reserve:[],
			unit_number: "",
			components:[],
			component:{},

			cross_test: "SI",
			compatibilities: [
				{key:"COMPATIBLE", name:'COMPATIBLE'},
				{key:"INCOMPATIBLE", name:'INCOMPATIBLE'},
				{key:"MENOS INCOMPATIBLE", name:'MENOS INCOMPATIBLE'},
			],
			compatibility:"",
			compatible:"",
			samples: [],
			sample_id:"",
			techniques: [],
			technique:"",

			group_rh:"",
			unit_id:"",
			table_incompatible:[],

			date:"",
			hour:"",
			petition_id: "",
			edit: false,
			obj_edit:{},
			require_authorization:false,
			code_component:"",
			blood_component_id:"",
			valid_caducidad:"",
			pat_aut_print_reserve:{},
			reserves:[],
			pat_notif_ehcos:{},
			pat_cross_test_interface:{},
			hide_form: false,

			manual:false,
			unit_analize:"",
			unit_analize_id:"",
			component_analize:{},
			code_component_analize:"",
			blood_component_id_analize:"",
			components_analize:[],
			tbl_analize:[],

			unit_g_rh:"",
			summary:"",
			pat_change_date_reserve:{},
			pat_auto_comp:{},
			original_val:"",
			patient_id:""
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);

				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});
		
		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date: moment(aux[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
				hour:hours,
			});
		});

		this.getPetitions();

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_CROSS_TEST_INTERFACE&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_cross_test_interface: response
			});

			if(response.value === 'NO'){
				this.setState({hide_form:false});
			}else if(response.value === 'YES'){
				this.setState({hide_form:true});
			}
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_AUT_PRINT_RESERVE&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_aut_print_reserve: response
			});
			
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_NOTIF_EHCOS&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_notif_ehcos: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_CHANG_DATE_RESERVE&x=', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_change_date_reserve:response});      					
      		}
		  });
		  
		this.getCriteriaAutoComp();
	}

	getCriteriaAutoComp(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_AUTO_COMP&x=', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_auto_comp:response, original_val: response.value});      					
      		}
      	});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getPetitions(){
		var id = this.props.match.params.id;

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'petitions?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					if(msg === ""){
						msg = 'Error al Cargar Peticiones';
					}
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				var table = [];
				var rh_group = "";

				
				rh_group = response.person.lookup_group !== null ?
							response.person.lookup_group + (
								response.person.lookup_rh === 'POSITIVO' ?
									'+'
								: response.person.lookup_rh === 'NEGATIVO' ?
									'-'
								: ''
							)
							: '';
					
				
				

				this.setState({
					petition_id: id,
					patient_id: response.patient.id,
					no_file: response.patient.number,
					patient: response.person.names+' '+response.person.lastname1+' '+response.person.lastname2,
					blood_components: response.petitions_blood_components !== undefined ? response.petitions_blood_components : [],
					table_reserve: [],
					table_incompatible:[],
					group_rh: rh_group,
					summary:response.delivered_comp_summary,
				});
				this.getDeletedUnits();
				this.getSamples(id);
				this.getTechniques();
				this.getUnitRerved(id);
				
			}
		});
	}
	
	getSamples(id){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'petitions/get_samples?petition_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({samples: response});
				if(response.length == 1){
					this.setState({sample_id:response[0].sample.id});
					this.getcross_test_results(response[0].sample.id);
				}
			}
		});
	}

	getcross_test_results(samples_id){
		fetch(Config.default.apiGateway.URL+'cross_test_results/by_sample?samples_id='+samples_id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({tbl_analize:[]});
				response.forEach(item =>{
					this.setState({
						tbl_analize:[...this.state.tbl_analize, {
							id:item.unit_id,
							unit: item.unit_number,
							component: item.component+" "+item.component_number
						}]
					});
				});
			}
		});
	}

	getTechniques(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=cross_techniques&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({techniques: response});
			}
		});
	}

	getUnitRerved(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_reserved/by_petition?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				this.setState({table_reserve:this.state.table_reserve});
				this.updateTables(response, '');
				
			}else{
				this.setState({edit: false});
			}
		});	
	}

	updateTables(response, update){
		var table_reserve = this.state.table_reserve, table_incompatible = [];

		response.map((res, i)=>{
			if(res.unit_reserved.compatibility === 'INCOMPATIBLE'){
				table_incompatible.push({
					component_id: res.unit_reserved.petition_blood_component_id,
					component: res.blood_component.component,
					component_type: res.blood_component.component_type,
					component_number:res.unit.component_number,
					cant: 1,
					id: res.unit_reserved.id,
					unit_id: res.unit.id,
					unit_number: res.unit.unit_number,
					rh_group_unit: res.unit.group+(res.unit.rh === 'POSITIVO' ? '+' :
									res.unit.rh === 'NEGATIVO' ? '-' : ''),
					compatibility: res.unit_reserved.compatibility,
					phenotype: "",
					require_authorization: res.unit_reserved.require_authorization,
					date_time:moment(res.unit_reserved.timestamp).format('DD/MM/YYYY HH:mm'),
					cross_technique_flag:res.unit_reserved.cross_technique_flag,
					edit_row:false,
					origin_compatibility:res.unit_reserved.compatibility,
					reason_status:null,
					user: res.user,
					reason_to_reserve: res.unit_reserved.reason_to_reserve !== null ?
										res.unit_reserved.reason_to_reserve.replace('_', ' ')
										:""
				})
				/*this.setState({
					table_incompatible: [...this.state.table_incompatible, {
						component_id: res.unit_reserved.petition_blood_component_id,
						component: res.blood_component.component,
						component_type: res.blood_component.component_type,
						component_number:res.unit.component_number,
						cant: 1,
						id: res.unit_reserved.id,
						unit_id: res.unit.id,
						unit_number: res.unit.unit_number,
						rh_group_unit: res.unit.group+(res.unit.rh === 'POSITIVO' ? '+' :
										res.unit.rh === 'NEGATIVO' ? '-' : ''),
						compatibility: res.unit_reserved.compatibility,
						phenotype: "",
						require_authorization: res.unit_reserved.require_authorization
					}]
				})*/
			}else{
				table_reserve.push({
					component_id: res.unit_reserved.petition_blood_component_id,
					component: res.blood_component.component,
					component_type: res.blood_component.component_type,
					component_number:res.unit.component_number,
					cant: 1,
					id: res.unit_reserved.id,
					unit_id: res.unit.id,
					unit_number: res.unit.unit_number,
					rh_group_unit: res.unit.group+(res.unit.rh === 'POSITIVO' ? '+' :
									res.unit.rh === 'NEGATIVO' ? '-' : ''),
					compatibility: res.unit_reserved.compatibility,
					phenotype: "",
					require_authorization: res.unit_reserved.require_authorization,
					date_time:moment(res.unit_reserved.timestamp).format('DD/MM/YYYY HH:mm'),
					cross_technique_flag:res.unit_reserved.cross_technique_flag,
					edit_row:false,
					origin_compatibility:res.unit_reserved.compatibility,
					reason_status:res.unit_reserved.reason_status,
					compatible:"",
					user:res.user,
					reason_to_reserve: res.unit_reserved.reason_to_reserve !== null ?
										res.unit_reserved.reason_to_reserve.replace('_', ' ')
										:""
				})
				/*this.setState({
					table_reserve: [...this.state.table_reserve, {
						component_id: res.unit_reserved.petition_blood_component_id,
						component: res.blood_component.component,
						component_type: res.blood_component.component_type,
						component_number:res.unit.component_number,
						cant: 1,
						id: res.unit_reserved.id,
						unit_id: res.unit.id,
						unit_number: res.unit.unit_number,
						rh_group_unit: res.unit.group+(res.unit.rh === 'POSITIVO' ? '+' :
										res.unit.rh === 'NEGATIVO' ? '-' : ''),
						compatibility: res.unit_reserved.compatibility,
						phenotype: "",
						require_authorization: res.unit_reserved.require_authorization
					}]
				})*/
			}
			
		})

		this.setState({table_reserve: table_reserve, table_incompatible:table_incompatible, reserves:response});
			
		//this.forceUpdate();

		setTimeout(()=>{
			if(this.state.pat_cross_test_interface.value !== 'YES'){
				document.getElementById('unit_number').focus();
				this._typeahead.getInstance().clear();
				//this.addNoCompatible();
			}
				
		}, 500);
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.type !== 'checkbox' ?
								e.target.value 
							: e.target.checked ? true : false

		});
		if(e.target.name === "sample_id"){
			if(e.target.value !== ""){
				this.getcross_test_results(e.target.value);
			}
			
		}else if(e.target.name === 'cross_test'){
			if(e.target.value !== ""){
				if(e.target.value === 'NO'){
					this.getCompatibility();
					this.setState({table_incompatible:[]});

				}else{
					this.setState({
						compatibilities:[
							{key:"COMPATIBLE", name:'COMPATIBLE'},
							{key:"INCOMPATIBLE", name:'INCOMPATIBLE'},
							{key:"MENOS INCOMPATIBLE", name:'MENOS INCOMPATIBLE'},
							//{key:"URGENCIA TRANSFUSIONAL", name:'URGENCIA TRANSFUSIONAL'},
						],
					});
				}

				setTimeout(()=>{
					this.getPetitions();	
				}, 500);
							
			}
		}else if(e.target.name === 'sample'){
			var value = parseInt(e.target.value);
			var index = this.state.samples.findIndex(obj => obj.id === value);

			
			if(index !== -1){
				if(this.state.samples[index].expired_date !== null){
					swal('Error', 'No puede seleccionar una muestra caducada', 'error');
				}
			}
		}else if(e.target.name === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}else if(e.target.name === 'manual'){
			this.setState({hide_form: e.target.checked ? false : true});
		}else if(e.target.name === 'technique'){
			if(e.target.value === 'SALINA_RAPIDA'){
				if(this.state.pat_auto_comp.value === 'YES'){
					this.state.pat_auto_comp.value = 'NO';
				}
			}else{
				this.state.pat_auto_comp.value = this.state.original_val;
			}

			this.forceUpdate();
		}else if(e.target.name === 'compatibility'){
			document.getElementById('compatibility').classList.remove('error');
		}
		if(e.target.required){
			document.getElementById(e.target.id).classList.remove("error");
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		if(e.target.name === 'unit_number' || e.target.name === 'unit_analize'){
      			this.getUnitComponent(e.target.name);
      		}

      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
    		
    		if(form.elements[index + 1] !== undefined){
    			form.elements[index + 1].focus();
    		}
      	}
   	}

   	getUnitComponent(type){
   		if(this.state[type] !== ""){
   			this.props.waiting.handleShow('Cargando...');
	   		fetch(Config.default.apiGateway.URL+'units/to_reserve?unit_number='+this.state[type]+
	   			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
	   			method: 'GET',
	   			headers: new Headers({
	   				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
	   				'Accept'		: 'application/json',
	   				'Content-Type'	: 'application/json'
	   			})
	   		}).then(res => {
	   			this.props.waiting.handleClose();
	   			if(res.ok){
	   				return res.json();
	   			}else{
	   				res.text().then((msg)=>{
	   					swal('Error', msg, 'error');
	   				});
	   			}
	   		}).then(response => {
	   			if(response !== undefined){
	   				if(type==='unit_number'){
	   					this._typeahead.getInstance().clear();
		   				this.setState({components: response});
	   				}else{
	   					this._typeahead_analize.getInstance().clear();
		   				this.setState({components_analize: response});
		   				
	   				}
	   			}
	   		});

   		}else{
   			swal('Error', 'Debe de ingresar un número de unidad', 'error');
   		}
   	}

	validateToSave(){
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    	   
    	inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}		   
		  	}
	    });
	    
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		
		return res;
	}

	onSave(){
		if(this.validateToSave()){			
			
			this.verifyCaducidad();
				
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	updateTableAfterAuth(id){
		var index = this.state.reserves.findIndex(obj => 
			obj.unit_reserved.unit_id === id
		)

		if(index !== -1){
			var reserve = this.state.reserves[index];

			var obj = {
				id:reserve.unit_reserved.id,
				petition_id: reserve.unit_reserved.petition_id,
				register_date:reserve.unit_reserved.register_date,
				register_hour:reserve.unit_reserved.register_hour,
				cross_technique_flag:reserve.unit_reserved.cross_technique_flag ,
				cross_technique:reserve.unit_reserved.cross_technique,
				samples_id:reserve.unit_reserved.samples_id,
				unit_id:id,
				petition_blood_component_id: null,
				require_authorization:false,
				sample_is_expired: reserve.unit_reserved.sample_is_expired,
				compatibility: reserve.unit_reserved.compatibility,
			}

			var method = 'PUT';
			var api = 'unit_reserved/'+obj.id;
			
			obj.timestamp = moment(this.state.date+' '+this.state.hour).format('YYYY-MM-DDTHH:mm:ss');

			fetch(Config.default.apiGateway.URL+api,{
				method: method,
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.getPetitions();
				}
			});
		}	
	}

	saving(force){
		var method = '';
		var api = '';
		var obj = {};
		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm a');

		var i_expired = this.state.samples.findIndex(obj => obj.sample.id === parseInt(this.state.sample_id));

		obj = {
			petition_id: parseInt(this.state.petition_id, 10),
			register_date:date.format('MM-DD-YYYY'),
			register_hour:this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
			cross_technique_flag:this.state.cross_test === 'SI' ? true : 
									this.state.cross_test === 'NO' ? false : '' ,
			cross_technique:this.state.technique === "" ? null : this.state.technique,
			samples_id:this.state.sample_id === "" ? null : parseInt(this.state.sample_id, 10),
			unit_id:this.state.component.unit.id,
			petition_blood_component_id: null,
			require_authorization:this.state.require_authorization,
			sample_is_expired: this.state.samples[i_expired].sample.expired_date !== null ? true : false,
		}

		if(this.state.cross_test === 'SI'){
			obj.compatibility = this.state.compatible;
		}else{
			obj.compatibility = this.state.compatible;
			obj.reason_to_reserve = this.state.compatibility;
		}
		

		var index_compatible = this.state.table_reserve.findIndex(item => 
			item.unit_id.toString().indexOf('u') === -1 && item.unit_id === obj.unit_id
		);
		
		var index_no_compatible = this.state.table_incompatible.findIndex(item => 
			item.unit_id === obj.unit_id
		);

		method = 'POST';
		api = 'unit_reserved?force='+force;
			
			console.log(obj);
		if(obj.register_date === 'Invalid date'){
			notify.show('Error, Fecha invalida', 'error');

		}else if(obj.register_hour === 'Invalid date'){
			notify.show('Error, Hora invalida', 'error');

		}else if(index_compatible !== -1 || index_no_compatible !== -1){
			swal('¡El registro no se puede agregar!', '¡La unidad ya fue registrada!', 'error');
		
		}else{
			
			
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+api,{
				method: method,
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						if(msg.indexOf('¿DESEA CONTINUAR?') !== -1){
							swal({
								title: 'Alerta',
								text: msg,
								type: 'warning',
								showCancelButton: true,
								confirmButtonColor: '#DD6B55',
								confirmButtonText: '¡Si, Continuar!',
								cancelButtonText: '¡No, Cancelar!',
								closeOnConfirm: true,
								closeOnCancel: true
							}, (isConfirm)=> {
								if (isConfirm) {
									this.saving('true');	
								}
							});
						}else{
							swal('Error', msg, 'error');
						}
					});
				}
			}).then(response => {
				if(response !== undefined){
					var item = response.res[response.res.length - 1].unit_reserved
					
					if(item.compatibility === 'COMPATIBLE'){
						if(this.state.pat_aut_print_reserve.value === 'YES'){
							this.printLabel('', item);
						}

						if(this.state.pat_notif_ehcos.value === 'YES'){
							this.modal_data.handleShow(response.xml);
						}
					}

					setTimeout(()=>{
						this.setState({
							component:{},
							unit_number:"",
							components:[],
							compatibility:"",
							compatible:"",
							require_authorization: "",
							code_component:"",
						})
						document.getElementById('unit_number').focus();
						this._typeahead.getInstance().clear();
					}, 500)
					
					this.getPetitions();
				}
			});
		}
	}

	loadComponent(e, type){
		if(e.length > 0){
			
			if(e[0].status !== 'BLOQUEADA'){
				if(type === 'analize'){
					this.setState({
						component_analize: e[0],
						unit_analize_id:e[0].unit.id,
						code_component_analize:e[0].label,
						blood_component_id_analize:e[0].unit.blood_component_id
					});

					setTimeout(()=>{this.onSaveAnalize();}, 500);
					
				}else{
					this.setState({
						component: e[0],
						unit_id:e[0].unit.id,
						code_component:e[0].label,
						blood_component_id:e[0].unit.blood_component_id,
						unit_g_rh:e[0].unit.group+(e[0].unit.rh === 'POSITIVO' ?'+'
									: e[0].unit.rh === 'NEGATIVO' ?	'-'	: '')
					});
					if(this.state.cross_test === 'SI'){
						if(this.state.pat_auto_comp.value !== 'NO'){
							this.verifyCompatibility(e[0].unit.id);
						}
						
					}else{
						//this.onSave();
					}
				}
			}else{
				swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
				if(type === 'analize'){
					this._typeahead_analize.getInstance().blur();
					this._typeahead_analize.getInstance().clear();
					this._typeahead_analize.getInstance().focus();
				}else{
					this._typeahead.getInstance().blur();
					this._typeahead.getInstance().clear();
					this._typeahead.getInstance().focus();
				}
					
			}
				
		}
	}

	verifyCompatibility(id){
		var error = "";
		if(this.state.group_rh === ""){
			error = "El paciente debe tener asignado Grupo & RH";
		}

		if(id === ""){
			error = "Debe ingresar un numero de componente";
		}

		if(error === ""){
			var group = this.state.group_rh.length === 2 ? this.state.group_rh[0] : this.state.group_rh[0]+this.state.group_rh[1];
			var rh = this.state.group_rh.charAt(this.state.group_rh.length - 1) === '+' ? 'POSITIVO' : 'NEGATIVO';
			this.props.waiting.handleShow('Veridicando compatibilidad...');
			fetch(Config.default.apiGateway.URL+'compatibility_groups/compare?patient_group='+group+
				'&patient_rh='+rh+'&unit_id='+id,{
				method: 'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					})
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						compatible: response
					});

					if(this.state.cross_test === 'SI'){
						switch(response){
							case 'COMPATIBLE':
								this.setState({
									compatibility:'true',
									require_authorization:false,
								});
								break;
							case 'URGENCIA TRANSFUSIONAL':
								this.setState({
									compatibility: 'true',
									require_authorization:true,
								});
								break;
							case 'INCOMPATIBLE':
								
								this.setState({
									compatibility: 'false',
									require_authorization:false
								});
								break;
						}

						if(response !== 'DESPLASMATIZADA'){
							var time = 500;
							if(response === 'INCOMPATIBLE'){
								swal({
									title: 'Información',
									text: 'La unidad es incompatible',
									type: 'warning',
								}, (isConfirm)=> {
									if (isConfirm) {
										this.onSave();
									}
								});
								
							}else{
								setTimeout(()=>{
									this.onSave();
								}, time);
							}
							
								
							
						}else{
							document.getElementById('unit_number').focus();
							this._typeahead.getInstance().clear();

							swal('Error', 'La unidad no puede ser agregada debido a que se encuentra desplasmatizada', 'error');	
						}
					}else{
						switch(response){
							case 'COMPATIBLE':
								this.setState({
									require_authorization:false,
								});
								break;
							case 'URGENCIA TRANSFUSIONAL':
								this.setState({
									require_authorization:true,
								});
								break;
							case 'INCOMPATIBLE':
								
								this.setState({
									require_authorization:false
								});
								break;
						}

						this.setState({compatible: response})

						if(response !== 'DESPLASMATIZADA'){
							var time = 500;
							if(response === 'INCOMPATIBLE'){
								swal({
									title: 'Información',
									text: 'La unidad es incompatible',
									type: 'warning',
								}, (isConfirm)=> {
									if (isConfirm) {
										this.onSave();
									}
								});
								
							}else{
								setTimeout(()=>{
									this.onSave();
								}, time);
							}
							
								
							
						}else{
							document.getElementById('unit_number').focus();
							this._typeahead.getInstance().clear();

							swal('Error', 'La unidad no puede ser agregada debido a que se encuentra desplasmatizada', 'error');	
						}
					}
					

				}
			});
			return 'ok';
		}else{
			swal('Error', error, 'error');
			return 'error';
		}
	}

	saveManual(){
		if(this.state.compatibility !== ""){
			document.getElementById('compatibility').classList.remove('error');
			this.setState({
				compatible: this.state.compatibility
			})

			setTimeout(()=>{
				switch(this.state.compatible){
					case 'COMPATIBLE':
						this.setState({
							compatibility:'true',
							require_authorization:false,
						});
						break;
					case 'URGENCIA TRANSFUSIONAL':
						this.setState({
							compatibility: 'true',
							require_authorization:true,
						});
						break;
					case 'INCOMPATIBLE':
						
						this.setState({
							compatibility: 'false',
							require_authorization:false
						});
						break;
					default:
						this.setState({
							compatibility: 'false',
							require_authorization:true
						});
						break;
				}

				if(this.state.compatible !== 'DESPLASMATIZADA'){
					var time = 500;
					if(this.state.compatible === 'INCOMPATIBLE'){
						swal({
							title: 'Información',
							text: 'La unidad es incompatible',
							type: 'warning',
						}, (isConfirm)=> {
							if (isConfirm) {
								this.onSave();
							}
						});
						
					}else{
						setTimeout(()=>{
							this.onSave();
						}, time);
					}
					
						
					
				}
			}, 500);
		}else{
			swal('Error', 'Debe seleccionar un elemento de compatibilidad', 'error');
			document.getElementById('compatibility').classList.add('error');
		}
		
		
	}

	verifyCaducidad(){
		fetch(Config.default.apiGateway.URL+'unit_reserved/is_valid?samples_id='+this.state.sample_id+
			'&date='+moment(this.state.date+' '+this.state.hour).format('YYYY-MM-DD H:mm'),{
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var flag = false;
				if(response){
					flag = true;
				}else{
					this.props.task_has_user_profiles.map((user)=>(
						user.type !== undefined ?
				        	user.type === "SEND_UNIT_SAMPLE_EXPIRED" ? 
				        		flag = true
							: flag = false
				      	:null
			    	))
				}
					
				if(flag){
					setTimeout(()=>{
						var component = this.state.component.blood_component.component_type;
						
						if(this.state.unit_g_rh !== this.state.group_rh){
							this.addIsogrupo();
						}else{
							this.saving('false');
						}
					}, 1000);
					
				}else{
					setTimeout(()=>{
						swal('Error', 'No es posible reservar la unidad, la muestra esta caducada', 'error');
					}, 1000);
					
				}

				this.setState({valid_caducidad:response});

			}
		})
	}

	viewPhenotypes(){
		this.modal_phenotype.handleShow();
	}

	viewAuth(e, id){
		e.preventDefault();

		this.modal_auth.handleShow(id);
	}

	getCompatibility(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=reserve_reason_units&option=actives&order=true',{
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res =>{
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({compatibilities: response});
			}
		})
	}

	onReturn(){
		var flag = true;
		this.state.table_reserve.map((t)=>{
			if(t.edit_row){
				flag = false;
			}
		})

		if(flag){
			this.props.history.push('/petition_register');
		}else{
			swal({
				title: '¿Está seguro?',
				text: '¿Existen elementos sin guardar, desea continuar?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#DD6B55',
				confirmButtonText: '¡Si, Terminar!',
				cancelButtonText: '¡No, Cancelar!',
				closeOnConfirm: true,
				closeOnCancel: true
			}, (isConfirm)=> {
				if (isConfirm) {
					this.props.history.push('/petition_register');				
				}
			});
		}	
	}

	printLabelCrossTest(e,item){
		if(e !== ''){
			e.preventDefault();
		}

		this.waiting_modal.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.id = item.id;
		obj.file_type = "label_reserve_cross_test";
		obj.nEtiqueta = [0];
		fetch(Config.default.apiGateway.URL+'labelsEditor', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
				swal('¡Error', result, 'error');
				return;
				});
			}
		})
		.then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else if(this.state.preview_print.value === "YES"){
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=> {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"cross_test_interface", "File": "'+aux[1]+'"}');
					}
				}
				
			}
		})
	}

	printLabel(e,item){
		if(e !== ''){
			e.preventDefault();
		}

		this.waiting_modal.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.id = item.id;
		obj.file_type = "label_reserve";
		obj.nEtiqueta = [0];
		fetch(Config.default.apiGateway.URL+'labelsEditor', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
				swal('¡Error', result, 'error');
				return;
				});
			}
		})
		.then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else if(this.state.preview_print.value === "YES"){
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=> {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_reserve", "File": "'+aux[1]+'"}');
					}
				}
				
			}
		})
	}

	deleteCrossTestUnit(e,unit_id){
		e.preventDefault();
		this.props.waiting.handleShow('Eliminando...');
		fetch(Config.default.apiGateway.URL+'cross_test_results/'+unit_id,{
			method:'delete',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					setTimeout(()=>{
						swal('Error', msg, 'error');
					},500);
				});
			}
		}).then(response=>{
			this.getcross_test_results(this.state.sample_id);
		});
	}

	deleteUnitReserved(e,id){
		e.preventDefault();
		swal({
			title: '¿Está seguro?',
			text: '¿Desea eliminar esta unidad?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_reserved/'+id,{
					method:'delete',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							setTimeout(()=>{
								swal('Error', msg, 'error');
							},500);
						});
					}
				}).then(response=>{
					if(response !== undefined){
						this.getPetitions();
					}
				})

				
			}
		});
	}

	printReport(e){
		e.preventDefault();

		var units = [];

		this.state.table_reserve.map((t)=>{
			units.push({unit_id: t.unit_id, unit: t.unit_number, folio:1})
		})

		this.modal_report.handleShow(units, "unit_reserve_doc");
	}

	onSaveAnalize(){
		if(this.state.sample_id !== ""){
			document.getElementById('sample_id').classList.remove('error');

			if(this.state.unit_analize_id !== ''){
				
				var obj = [{code:"",result:"",samples_id:this.state.sample_id, unit_id:this.state.unit_analize_id}];

				var index = this.state.tbl_analize.findIndex(item =>
					item.id === this.state.unit_analize_id
				);

				if(index === -1){
					fetch(Config.default.apiGateway.URL+'cross_test_results',{
						method: 'post',
						body: JSON.stringify(obj),
						headers: new Headers({
							'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						if(res.ok){
							return res.json();
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							});
						}
					}).then(response => {
						if(response !== undefined){
							this.setState({
								tbl_analize:[...this.state.tbl_analize, {
									id:this.state.unit_analize_id,
									unit: this.state.component_analize.donation_number,
									component: this.state.component_analize.blood_component.component+" "+
										this.state.component_analize.component_number
								}],
								unit_analize:"",
								unit_analize_id:"",
								component_analize:{},
								code_component_analize:"",
								blood_component_id_analize:"",
								components_analize:[],
							});

							this._typeahead_analize.getInstance().clear();
						}
					});

				}else{
					swal('Error', 'El componente que intenta agregar ya se encuentra registrado', 'error');
				}

			}else{
				swal('Error', 'Debe seleccionar un componente a analizar', 'error');
			}

		}else{
			swal('Error', 'Debe seleccionar una muestra', 'error');

			document.getElementById('sample_id').classList.add('error');
		}
	}

	addIsogrupo(){
		swal({
			title: '¿Unidad a ISO GRUPO?',
			text: '¿Desea agregar esta unidad?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Agregar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				setTimeout(()=>{
					this.saving('false');
				}, 500)
			}else{
				setTimeout(()=>{
					this.setState({
						component:{},
						unit_number:"",
						components:[],
						compatibility:"",
						compatible:"",
						require_authorization: "",
						code_component:"",
					})
					document.getElementById('unit_number').focus();
					this._typeahead.getInstance().clear();
				}, 500)
			}
		});
	}

	editionEnable(e, i){
		e.preventDefault();

		var tbl = this.state.table_reserve;
		tbl[i].edit_row = true;
		this.setState({table_reserve:tbl});
	}

	editionCancel(e, i){
		e.preventDefault();

		var tbl = this.state.table_reserve;
		tbl[i].edit_row = false;
		tbl[i].compatibility = tbl[i].origin_compatibility;
		this.setState({table_reserve:tbl});
	}

	changeCompatibility(e, i){
		e.preventDefault();

		var tbl = this.state.table_reserve;
		tbl[i].compatibility = e.target.value;
		if(e.target.value !== 'MENOS INCOMPATIBLE' || e.target.value !== 'URGENCIA TRANSFUSIONAL'){
			tbl[i].reason_status = null;
		}
		this.setState({table_reserve:tbl});
	}

	updateReserve(e, i){
		e.preventDefault();
		var tbl = this.state.table_reserve;
		var id = tbl[i].id;
		var status = tbl[i].compatibility;
		var reason = tbl[i].reason_status;
		var authorization = status === 'URGENCIA TRANSFUSIONAL' || status === 'MENOS INCOMPATIBLE' ? true : false;
		

		var obj = {
			new_status:status,
			require_authorization:authorization,
			reason_status: reason
		}

		fetch(Config.default.apiGateway.URL+'unit_reserved/change_status/'+id,{
			method:'put',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text.then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({table_reserve:[]});
				this.getUnitRerved(this.state.petition_id);
			}
		})
	}

	changeReason(e, i){
		var reserve = this.state.table_reserve;

		reserve[i].reason_status = e.target.value;

		this.setState({table_reserve:reserve});
	}

	getDeletedUnits(){
		fetch(Config.default.apiGateway.URL+'petitions/reserves_removed?petition_id='+this.props.match.params.id,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(msg => {
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			var table_reserve = this.state.table_reserve;
			response.map((res, i) =>{
				table_reserve.push({
					component_id: 'd'+i,
					component: res.component,
					component_type: '',
					component_number: res.component_number,
					cant: 1,
					id: 'd'+i,
					unit_id: 'u'+i,
					unit_number: res.unit_number,
					rh_group_unit: res.g_rh,
					compatibility: '',
					phenotype: "",
					require_authorization: '',
					date_time:moment(res.timestamp_reserved).format('DD/MM/YYYY HH:mm'),
					cross_technique_flag:'',
					edit_row:false,
					origin_compatibility:'',
					reason_status:'deleted',
					compatible:"RESERVA ELIMINADA",
					user: res.user
				})
			})

			this.setState({table_reserve:table_reserve});
		})
	}

	openHistory(e){
		e.preventDefault();
		
		this.modal_history.handleShow(this.state.patient_id);
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return (
			<div className="col-xs-12">
				
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Reserva de Unidades
					</h5>
				</div>
				
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
						<span className="span-min" >Prueba Cruzada</span>
					</div>
					<div className="col-xs-12 reservedInput">
						<select className="form-control" name="cross_test" id="cross_test"
							value={this.state.cross_test} onChange={this.handleChange} >
							<option value="">Seleccione...</option>
							<option value="SI">SI</option>
							<option value="NO">NO</option>
						</select>
					</div>
				</div>

				{this.state.cross_test !== "" ?
					<form noValidate>
						<hr style={{width:"100%", margin:'5px'}}/>
						<div className="col-xs-12 col-sm-6">
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-4" style={{textAlign:"right"}}>
									<span className="span-min">Número de Expediente</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<span className="patient-name">{this.state.no_file}</span>
								</div>
							</div>
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-4" style={{textAlign:"right", marginTop:"10px"}}>
									<span className="span-min">Nombre de Paciente</span>
								</div>
								<div className="col-xs-12 col-sm-4">
									<span className="patient-name" style={{marginRight:"20px"}}>{this.state.patient}</span>

									<span style={{color:"red", fontWeight:"bold", fontSize:"25px"}}>{this.state.group_rh}</span>
								</div>
							</div>
							
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-4"  style={{textAlign:"right"}}>
									<span className="span-min">Muestras</span>
								</div>
								<div className="col-xs-12 col-sm-4">
									<select className="form-control" name="sample_id" id="sample_id" required
										value={this.state.sample_id} onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										{this.state.samples.map((s, i)=>{
											return <option key={i} value={s.sample.id}>
												{s.sample.number} - {moment(s.sample.timestamp, 'YYYY-MM-DD H:mm').format('DD/MM/YYYY HH:mm')} 
												{s.sample.expired_date !== null ? ' - '+ 'Caducada' : ''}
											</option>
										})}
									</select>
								</div>
							</div>	
							
							<div className="col-xs-12 " style={{marginTop:"5px"}}>
								<div className="col-xs-12 col-sm-4"  style={{textAlign:"right"}}>
									<span className="span-min">Técnica</span>
								</div>
								<div className="col-xs-12 col-sm-4">
									<select className="form-control" name="technique" id="technique"
										value={this.state.technique} onChange={this.handleChange} >
										<option value="">Seleccione...</option>
										{this.state.techniques.map((t, i)=>{
											return <option key={i} value={t.key}>
												{t.name}
											</option>
										})}
									</select>
								</div>
							</div>	
					

							<div className="col-xs-12 form-group" style={{marginTop:"5px"}}>
								<div className="col-xs-12 col-sm-4" style={{textAlign:"right"}}>
									<span className="span-min">Fecha</span>
								</div>
								<div className="col-xs-12 col-sm-2">
									<input type="date" name="date" id="date" className="form-control hour-input"
										value={this.state.date} onChange={this.handleChange} 
										disabled={this.state.pat_change_date_reserve.value === 'NO'}
									/>
								</div>
								<div className="col-xs-12 col-sm-2" style={{paddingRigth:'0', paddingLeft:'0'}}>
									<span className="span-min">Hora</span>
									<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" 
										data-inputmask-inputformat="HH:MM" data-inputmask-placeholder="-" 
										value={this.state.hour} onChange={this.handleChange}
										disabled={this.state.pat_change_date_reserve.value === 'NO'}
										className="form-control" style={{marginLeft:"6%", width:"65%", display:"inline"}} />
									
								</div>
							</div>
						</div>

						{this.state.pat_cross_test_interface.value === 'YES' ?
							<div className="col-xs-12 col-sm-6">
								<fieldset>
									<legend>Unidades a Analizar</legend>
									<div className="col-xs-12 form-group">
										<div className="col-xs-12 col-sm-4">
											<span>No. Unidad</span>
											<input name="unit_analize" id="unit_analize" value={this.state.unit_analize} 
												className="form-control" onChange={this.handleChange} 
												onKeyPress={(e) => this.validateInput(e)} />
										</div>
										<div className="col-xs-12 col-sm-4">
											<span>Componente</span>
											<Typeahead
										       	labelKey={(option) => `${option.label}`}
										        minLength={0}
										        maxLength={50}
										        inputProps={{
									          		name:"component_analize",
									          		required:'required',
									          		id:"component_analize"
									          	}}
									          	id="codeComponentAnalize"
										        options={this.state.components_analize}
										        onChange={(e)=>this.loadComponent(e, 'analize')}
										        ref={ref => this._typeahead_analize = ref}
										        isLoading={this.state.isLoading_1}
										        selectHintOnEnter={true}
										        delay={600}
										        paginationText="Mostrar mas resultados..."
										    />
										</div>
										<div className="col-xs-12 col-sm-4" style={{marginTop:'18px'}}>
											<FloatingActionButton className="action-btn" mini={true}
												iconStyle={{height: 25, width: 25}} onClick={this.onSaveAnalize} >
						                      	<ContentAdd/>
						                    </FloatingActionButton> 
										</div>
									</div>
									<div className="col-xs-12 col-sm-9">
										<Table responsive hover>
											<thead>
												<tr>
													<th>No. Unidad</th>
													<th>Componente</th>
													<th></th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												{this.state.tbl_analize.map((t, i)=>(
													<tr key={i}>
														<td>{t.unit}</td>
														<td>{t.component}</td>
														<td>
															<SvgIcon icon={priceTag} style={{cursor:"pointer"}} onClick={(e)=>this.printLabelCrossTest(e,t)}/>
														</td>
														<td>
														<button className="btn btn-info btn-xs" title="Eliminar" 
															style={{marginRight:'3px'}} 
															onClick={(e) =>  this.deleteCrossTestUnit(e, t.id)}>
															<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
														</button>
														</td>
													</tr>
												))}
											</tbody>
										</Table>
									</div>
								</fieldset>
							</div>
						:null}
						<hr style={{width:"100%"}} />
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2" style={{textAlign:'right'}}>
								<span>Resumen de unidades solicitadas: </span>
							</div>
							<div className="col-xs-12 col-sm-10">
								<span style={{marginLeft:'8px'}}>{this.state.summary}</span>
							</div>
						</div>
						{this.state.pat_cross_test_interface.value === 'YES' ?
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-2" style={{textAlign:'right'}}>
									<input type="checkbox" name="manual" id="manual" value={this.state.manual}
										checked={this.state.manual} onChange={this.handleChange} />
									<span style={{marginLeft:'8px'}}>Carga Manual</span>
								</div>
							</div>
						:null}

						<div className="col-xs-12 form-group" hidden={this.state.hide_form}>
							<div className="col-xs-12 col-sm-2" style={{paddingTop:"20px", textAlign:"right"}}>
								<span className="span-min">Componentes Solicitados</span>
							</div>
							<div className="col-xs-12 col-sm-1">
								<span className="span-min">No. Unidad</span>
								<input type="text" className="form-control" name="unit_number" id="unit_number"
									value={this.state.unit_number} onChange={this.handleChange} 
									onKeyPress={(e) => this.validateInput(e)} 
									required/>
							</div>
							<div className="col-xs-12 reservedHour">
								<span className="span-min">No. Componente</span>
								<Typeahead
						          labelKey={(option) => `${option.label}`}
						          minLength={0}
						          maxLength={50}
						          inputProps={{
					          		name:"code_component",
					          		required:'required',
					          		id:"code_component"
					          	  }}
					          	  id="codeComponent"
						          options={this.state.components}
						          onChange={this.loadComponent}
						          ref={ref => this._typeahead = ref}
						          isLoading={this.state.isLoading}
						          selectHintOnEnter={true}
						          delay={600}
						          paginationText="Mostrar mas resultados..."
						        />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">
									{this.state.cross_test === 'SI' ?
										'Compatibilidad'
									: 'Motivos de Reserva de Unidades'}
								</span>
								<select className="form-control" name="compatibility" id="compatibility"
									value={this.state.compatibility} 
									disabled={this.state.pat_auto_comp.value === 'NO' ? false : this.state.cross_test === 'SI'}
									onChange={this.handleChange} required={this.state.cross_test !== 'SI'}>
									<option value="">Seleccione...</option>
									{this.state.compatibilities.map((c, i)=>{
										return <option key={i} value={c.key}>
											{c.name}
										</option>
									})}
								</select>
							</div>
							<div className="col-xs-12 col-sm-1" style={{paddingTop:"18px"}}>
								<button type="button" className="btn btn-info" 
									onClick={(e)=>
										this.state.pat_auto_comp.value === 'NO' ?
											this.state.cross_test === 'SI'	?
												this.state.compatibility === 'COMPATIBLE' ?
													this.verifyCompatibility(this.state.unit_id)	
												: this.saveManual()
											: this.verifyCompatibility(this.state.unit_id)
										: this.verifyCompatibility(this.state.unit_id)}>
									Agregar
								</button>
							</div>
						</div>
						
							

						<fieldset className="col-xs-12">
							<legend>Compatibles</legend>
							<Table responsive hover>
								<thead>	
									<tr>
										<th style={{width:'3%'}}>Cant.</th>
										<th style={{width:'10%'}}>Fecha Hora Reserva</th>
										<th style={{width:'15%'}}>Usuario</th>
										<th style={{width:'13%'}}>Componente</th>
										<th style={{width:'6%'}}>No. Unidad</th>
										<th style={{textAlign:"center",width:'8%'}}>No. Componente</th>
										<th style={{textAlign:"center",width:'7%'}}>Grupo & RH</th>
										<th style={{textAlign:"center",width:'3%'}}>Fenotipos</th>
										<th style={{textAlign:"center",width:'3%'}}>Etiqueta</th>
										<th style={{width:'6%'}}>Autorización</th>
										<th style={{width:'13%'}}>Estatus</th>
										<th style={{width:'6%'}}>Motivo</th>
										<th style={{width:'10%'}}></th>
										
									</tr>
								</thead>
								<tbody>
									{this.state.table_reserve.map((t, i)=>{
										return <tr key={i}>
											<td>{t.cant}</td>
											<td>{t.date_time}</td>
											<td>{t.user}</td>
											<td>{t.component}</td>
											<td>{t.unit_number}</td>
											<td align="center">{t.component_number}</td>
											<td align="center">{t.rh_group_unit}</td>
											
											<td align="center">
												{t.reason_status !== 'deleted' &&
													<SvgIcon icon={search} style={{cursor:"pointer"}} disabled={t.disabled}
														onClick={this.viewPhenotypes} />
												}
											</td>
											<td align="center">
												{t.reason_status !== 'deleted' && t.unit_number !== "" ?
													!t.cross_technique_flag ?
														<SvgIcon icon={priceTag} style={{cursor:"pointer"}} onClick={(e)=>this.printLabel(e,t)}/>
													//:t.compatible === 'COMPATIBLE' || t.compatibility === 'COMPATIBLE' ?
													:t.origin_compatibility === 'COMPATIBLE' ?
														<SvgIcon icon={priceTag} style={{cursor:"pointer"}} onClick={(e)=>this.printLabel(e,t)}/>
													//: t.compatible === 'URGENCIA TRANSFUSIONAL' || t.compatibility === 'URGENCIA TRANSFUSIONAL' ?
													:t.origin_compatibility === 'URGENCIA TRANSFUSIONAL' || t.origin_compatibility === 'MENOS INCOMPATIBLE'?
														!t.require_authorization ?
															<SvgIcon icon={priceTag} style={{cursor:"pointer"}}  onClick={(e)=>this.printLabel(e,t)}/>
														:null
													:null
												:null}
											</td>
											<td>
												
												{t.reason_status !== 'deleted' ?
													t.origin_compatibility === 'URGENCIA TRANSFUSIONAL' || t.origin_compatibility === 'MENOS INCOMPATIBLE'?
														t.require_authorization ?<a href="" onClick={(e) => this.viewAuth(e, t.unit_id)}>
															PENDIENTE <SvgIcon icon={lock} style={{cursor:"pointer"}} /></a>
														: <span>AUTORIZADA <SvgIcon icon={unlocked} style={{cursor:"pointer"}}/></span>
													: ''
												: ''}
											</td>
											<td>
												<select disabled={!t.edit_row} className="form-control" 
													value={t.compatible || t.compatibility}
													onChange={(e)=> this.changeCompatibility(e, i)}>
													<option value="COMPATIBLE">COMPATIBLE</option>
													<option value="INCOMPATIBLE">INCOMPATIBLE</option>
													<option value="MENOS INCOMPATIBLE">MENOS INCOMPATIBLE</option>
													{/*<option value="URGENCIA TRANSFUSIONAL">URGENCIA TRANSFUSIONAL</option>*/}
													{t.reason_status === 'deleted' && 
														<option value="RESERVA ELIMINADA"> RESERVA ELIMINADA</option>
													}
												</select>
												{t.reason_status !== 'deleted' ?
													(t.compatible === "MENOS INCOMPATIBLE" || t.compatible === 'URGENCIA TRANSFUSIONAL') || 
													(t.compatibility === "MENOS INCOMPATIBLE" || t.compatibility === 'URGENCIA TRANSFUSIONAL') ?
														<input type="text" className="form-control" style={{marginTop:'5px', display:'block'}}
															onChange={(e)=>this.changeReason(e, i)} placeholder="Motivo..."
															value={t.reason_status} />
													: null
												:null}
												
											</td>
											
											<td>
												{t.reason_to_reserve}
											</td>
											<td>
												{t.reason_status !== 'deleted' ?
													!t.edit_row ?
														<div>
															<button className="btn btn-info btn-xs" title="Editar" 
																style={{marginRight:'3px'}} 
																onClick={(e) =>  this.editionEnable(e, i)}>
									                            <SvgIcon icon={pencil} style={{paddingTop:"3px"}}/>
									                        </button>
															<button className="btn btn-info btn-xs" title="Eliminar" 
																style={{marginRight:'3px'}} 
																disabled={!this.props.task_unit_reserves.delete}
																onClick={(e) =>  this.deleteUnitReserved(e, t.id)}>
									                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
									                        </button>
								                        </div>
								                    :<div>
														<button className="btn btn-info btn-xs" title="Guardar" 
															style={{marginRight:'3px'}} 
															onClick={(e) =>  this.updateReserve(e, i)}>
								                           	<SvgIcon icon={floppyDisk} style={{paddingTop:"3px"}}/>
								                        </button>
														<button className="btn btn-info btn-xs" title="Cancelar" 
															style={{marginRight:'3px'}} 
															onClick={(e) =>  this.editionCancel(e, i)}>
								                             <SvgIcon icon={cross} style={{paddingTop:"3px"}}/>
								                        </button>
							                        </div>
							                    :null}
											</td>
										</tr>
									})}
								</tbody>
							</Table>
						</fieldset>

						<fieldset className="col-xs-12">	
							<legend>Incompatibles</legend>
							<div className="col-xs-12 col-sm-9" style={{paddingLeft:'0'}}>
								<Table responsive hover 
									className="table-data">
									<thead>
										<tr>
											<th style={{background:'var(--bg-menu)', color:'var(--color-menu)'}} className="cant">Cant.</th>
											<th style={{width:'12%',background:'var(--bg-menu)', color:'var(--color-menu)'}}>Fecha Hora Reserva</th>
											<th style={{width:'15%',background:'var(--bg-menu)', color:'var(--color-menu)'}}>Usuario</th>
											<th style={{background:'var(--bg-menu)', color:'var(--color-menu)'}} className="component">Componente</th>
											<th style={{background:'var(--bg-menu)', color:'var(--color-menu)'}} className="unit">No. Unidad</th>
											<th style={{background:'var(--bg-menu)', color:'var(--color-menu)'}} className="no_component">No. Componente</th>
											<th style={{background:'var(--bg-menu)', color:'var(--color-menu)'}} className="g_rh">Grupo & RH</th>
											<th style={{background:'var(--bg-menu)', color:'var(--color-menu)'}} className="btns"></th>
										</tr>
									</thead>
									<tbody>
										{this.state.table_incompatible.map((t, i)=>{
											return <tr key={i}>
												<td>{t.cant}</td>
												<td>{t.date_time}</td>
												<td>{t.user}</td>
												<td>{t.component}</td>
												<td >{t.unit_number}</td>
												<td align="center">{t.component_number}</td>
												<td style={{paddingLeft: '5%'}}>{t.rh_group_unit}</td>
												<td>
													<button className="btn btn-info btn-xs" title="Eliminar" 
														style={{marginRight:'3px'}} 
														disabled={!this.props.task_unit_reserves.delete}
														onClick={(e) =>  this.deleteUnitReserved(e, t.id)}>
														<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
													</button>
												</td>
											</tr>
										})}
										
									</tbody>
								</Table>
							</div>
						</fieldset>
				
						<ModalPhenotype {...this.props} onRef={ref => (this.modal_phenotype = ref)} />
						<ModalAuth {...this.props} saving={this.updateTableAfterAuth} onRef={ref => (this.modal_auth = ref)} />
						
						<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
							<button className="toolIcon" 
								onClick={(e)=>this.printReport(e)}>
								<SvgIcon size={40} icon={print} />
								<div className="col-xs-12">
									<span>Imprimir</span>
								</div>
							</button>
							<button className="toolIcon"
								onClick={(e)=>{e.preventDefault(); return this.props.history.push('/petition_register/unitSend/'+this.state.petition_id);}}	>
								<SvgIcon size={40} icon={upload2} />
								<div className="col-xs-12">
									<span>Envio</span>
								</div>
							</button>
							<button className="toolIcon" 
								onClick={(e)=>this.openHistory(e)}>
								<SvgIcon size={40} icon={history} />
								<div className="col-xs-12">
									<span>Historial</span>
								</div>
							</button>
						</div>
						<div className="col-xs-12" style={{textAlign:'center'}}>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
			        	</div>
						<Notifications />
					</form>
						
				: <div className="col-xs-12" style={{textAlign:'center'}}>	 
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
				</div>}
				<ModalData {...this.props} onRef={ref => (this.modal_data = ref)}/>
				<ModalReport {...this.props} onRef={ref => (this.modal_report = ref)} socket={this.props.socket}/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>

				<ModalHistory {...this.props} onRef={ref => (this.modal_history = ref)}/>
			</div>
		)
	}
}

export default translate('translations') (UnitReserve);